<mds-dialog dialogTitle="Warning">
    <mds-dialog-content>
        <div class="o-grid__row">
            <div class="o-grid__item">Are you sure you want to delete this request?</div>
        </div>
    </mds-dialog-content>
    <mds-dialog-actions [align]="'end'">
        <div class="flex flex-row gap-medpace">
            <mds-button
                [id]="'cancel-btn'"
                label="Cancel"
                [variant]="'outline'"
                (clickEvent)="closeDialog()"
            ></mds-button>
            <mds-button
                [id]="'confirm-btn'"
                label="Yes"
                [color]="'primary'"
                [variant]="'filled'"
                (clickEvent)="deleteConfirm()"
            ></mds-button>
        </div>
    </mds-dialog-actions>
</mds-dialog>
